import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AboutMe from './components/AboutMe/AboutMe';
import Header from './components/Header/Header';
import Projects from './components/Projects/Projects';
import MotionClicker from './components/Games/MotionClicker/MotionClicker';
import RotatingStar from './components/Games/RotatingStar/RotatingStar';
import ClickSpeed from './components/Games/ClickSpeed/ClickSpeed';
import MomentumSpinner from './components/Games/MomentumSpinner/MomentumSpinner';
import ShrinkingTarget from './components/Games/ShrinkingTarget/ShrinkingTarget';
import TestLatency from './components/Games/TestLatency/TestLatency';
import UnicornRun from './components/Games/UnicornRun/UnicornRun';
import AsteroidDefense from './components/Games/AsteroidDefense/AsteroidDefense';
import GamesLanding from './components/Games/GamesLanding/GamesLanding';
import Click6 from './components/Games/Click6/Click6';
import ModernSamurai from './components/Games/ModernSamurai/ModernSamurai';
import SamuraiStats from './components/Games/ModernSamurai/SamuraiStats';
import styles from './App.module.css';
import AboutMeSide from './components/AboutMe/AboutMeSide';
import NotFound from './components/NotFound/NotFound';

import ThreeByTwo from './components/Games/ModernSamurai/SubGames/ThreeByTwo';
import SevenYardDraw from './components/Games/ModernSamurai/SubGames/SevenYardDraw';
import BillDrill from './components/Games/ModernSamurai/SubGames/BillDrill';
import TwentyFiveYardShot from './components/Games/ModernSamurai/SubGames/TwentyFiveYardShot';
import FullTest from './components/Games/ModernSamurai/SubGames/FullTest';
import ThreeYardReload from './components/Games/ModernSamurai/SubGames/ThreeYardReload';
import DepthTransitions from './components/Games/ModernSamurai/SubGames/DepthTransitions';
import TexasStarSamurai from './components/Games/ModernSamurai/SubGames/TexasStarSamurai';
import Click6Samurai from './components/Games/ModernSamurai/SubGames/Click6Samurai';
import Click6SamuraiGrid from './components/Games/ModernSamurai/SubGames/Click6SamuraiGrid';
import Click6SamuraiW from './components/Games/ModernSamurai/SubGames/Click6SamuraiW';
import OneOneTwoOneOneDrill from './components/Games/ModernSamurai/SubGames/OneOneTwoOneOneDrill';

function App() {
  // when in prod, don't be outputting to console.
  if (process.env.NODE_ENV === 'production') {
    console.log = () => { };
    console.error = () => { };
    console.debug = () => { };
  }
  // console.log('test');

  return (
    <>
      <Routes>
        <Route path="/" element={
          <>
            <Header />
            <div className={styles.wrapper}>
              <div className={styles.left}>
                <AboutMeSide />
              </div>
              <div className={styles.right}>
                <AboutMe />
                <Projects />
              </div>
            </div>
          </>
        } />
        <Route path="/games" element={<GamesLanding />} />
        <Route path="/motion-clicker" element={<MotionClicker />} />
        <Route path="/rotating-star" element={<RotatingStar />} />
        <Route path="/click-speed" element={<ClickSpeed />} />
        <Route path="/momentum-spinner" element={<MomentumSpinner />} />
        <Route path="/shrinking-target" element={<ShrinkingTarget />} />
        <Route path="/test-latency" element={<TestLatency />} />
        <Route path="/unicorn-run" element={<UnicornRun />} />
        <Route path="/asteroid-defense" element={<AsteroidDefense />} />
        <Route path="/click-6" element={<Click6 />} />
        <Route path="/modern-samurai" element={<ModernSamurai />} />
        <Route path="/modern-samurai/stats" element={<SamuraiStats />} />
        <Route path="/modern-samurai/3x2" element={<ThreeByTwo />} />
        <Route path="/modern-samurai/7yd" element={<SevenYardDraw />} />
        <Route path="/modern-samurai/bill" element={<BillDrill />} />
        <Route path="/modern-samurai/25yd" element={<TwentyFiveYardShot />} />
        <Route path="/modern-samurai/full" element={<FullTest />} />
        <Route path="/modern-samurai/3y-reload" element={<ThreeYardReload />} />
        <Route path="/modern-samurai/depth-transitions" element={<DepthTransitions />} />
        <Route path="/modern-samurai/texas-star" element={<TexasStarSamurai />} />
        <Route path="/modern-samurai/1-1-2-1-1" element={<OneOneTwoOneOneDrill />} />
        <Route path="/modern-samurai/click-6" element={<Click6Samurai />} />
        <Route path="/modern-samurai/click-6-grid" element={<Click6SamuraiGrid />} />
        <Route path="/modern-samurai/click-6-w" element={<Click6SamuraiW />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
